import { useContext, useEffect } from 'react'
import { useParams, withRouter } from 'react-router-dom'
import * as H from 'history'
import { Extraction } from 'entities/extraction'
import { GlobalStateContext } from 'contexts/global_state_context'
import { A4 } from 'components/shared/print'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Flex } from 'components/shared/flex'
import { Button } from 'react-bootstrap'
import lodash from 'lodash'
import { useFetchCouponCodesApi } from 'api/coupon_code'
import { CouponCode, CouponCodeSearchForm } from 'entities/coupon_code'
import { Barcode } from 'components/shared/widget'
import { setPageSize } from 'utils/util'

type Props = {
    history: H.History
}

const PreviewCouponCodesPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const params = useParams<{ id: string }>()
    const query = useQuery<CouponCodeSearchForm>()
    const searchForm = useForm<CouponCodeSearchForm>({ ...query, couponId: Number(params.id) })
    const api = useFetchCouponCodesApi(searchForm)
    const form = useForm<{ note?: string }>({})

    useEffect(() => {
        api.execute()
        setPageSize('portrait')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
    }, [api.loading])

    const chunks = (): Extraction[][] => {
        return lodash.chunk(api.response.results, 21)
    }

    const count = 0
    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            {api.response.results &&
                chunks().map((chunk, index) => {
                    return (
                        <A4 padding={0} landscape={false} key={'page' + index}>
                            <Flex flexWrap="wrap" className="">
                                {chunk.map((couponCode: CouponCode, index) => {
                                    return (
                                        <>
                                            <Flex
                                                alignItems={'center'}
                                                key={'coupon-code' + couponCode.id + `${index}`}
                                                style={{ height: '42.3mm', width: '69.6mm', padding: '9.5mm 10mm' }}
                                            >
                                                <Flex style={{ width: '100%', height: '100%' }} justifyContent="center" alignItems={'center'}>
                                                    <Barcode value={couponCode.value!} width={1.7} height={55} fontSize={10}></Barcode>
                                                </Flex>
                                            </Flex>
                                            {/* {index % 3 != 2 && <div style={{ width: '0.1mm', borderRight: 'dashed 0.1mm #888', height: '42.3mm' }}></div>} */}
                                        </>
                                    )
                                })}
                            </Flex>
                        </A4>
                    )
                })}
        </>
    )
}

export default withRouter(PreviewCouponCodesPage)
